import Loader from "../Loader"

const Component = () => {
  return (
    <Loader />
  )
}

export default Component